import { render } from "./SignUpModal.vue?vue&type=template&id=e842167a"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__